module.exports = __webpack_public_path__ + "img/Pic_PT_New.a02ea904.png";